import { type WrappedInsightTotalEarningsAttributes } from "@clipboard-health/contract-backend-main";
import { Image, Text } from "@clipboard-health/ui-components";
import { Box, Stack } from "@mui/material";

import coinIcon from "../../assets/coin-wrapped.png";

interface TotalEarningsContentProps {
  attributes: WrappedInsightTotalEarningsAttributes;
}

function formatCurrency(amount: number): string {
  return new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "USD",
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  }).format(amount);
}

export function TotalEarningsContent(props: TotalEarningsContentProps) {
  const { attributes } = props;

  return (
    <Stack flex={1} position="relative" overflow="hidden">
      {/* White streak effect - positioned to pass through coin center */}
      {/* Coin center is at approximately (57%, 65%) on this page */}
      <Box
        position="absolute"
        sx={{
          top: "-50%",
          left: "-50%",
          width: "200%",
          height: "200%",
          backgroundSize: "100% 100%",
          backgroundPosition: "30% 55%", // Adjusted to hit coin at 40.6% top, 57% center
          pointerEvents: "none",
        }}
      />

      {/* Text section - top left */}
      <Stack
        position="absolute"
        sx={{
          top: "12%",
          left: "7.7%",
        }}
        spacing={3}
      >
        <Text variant="body1" color="white">
          You earned
        </Text>
        <Text variant="h1" color="white" sx={{ fontSize: "4rem", lineHeight: 1 }}>
          {formatCurrency(attributes.earnings)}
        </Text>
        <Text variant="body1" color="white">
          in 2025
        </Text>
      </Stack>

      {/* Coin - positioned based on Figma: 357x357 at top 330px, left 35px, angle 2.9deg on 375x812 page */}
      <Box
        position="absolute"
        sx={{
          top: "40.6%", // 330 / 812
          left: "9.3%", // 35 / 375
        }}
      >
        <Image
          src={coinIcon}
          alt="Coin"
          width="95vw" // 357 / 375
          height="auto"
          sx={{ transform: "rotate(2.9deg)" }}
        />
      </Box>
    </Stack>
  );
}
